import React, { useMemo } from "react";
import {
  BmiCategory,
  GoalOverview,
  NutritionStratergy,
  WorkoutFocus,
  LongTerm,
} from "@utils/defaultImages";
const AdviseMeRightPanel = ({ message, AdviseMeSidePic, t }) => {
  const nutrientData = useMemo(
    () => [
      {
        label: t("BMI & Category"),
        icon: <BmiCategory className="w-[24px] h-[24px]" />,
        tabColor: "#F0FFFF",
        value: message?.["BMI & Category"],
      },
      {
        label: t("Goal Overview"),
        icon: <GoalOverview className="w-[24px] h-[24px]" />,
        tabColor: "#FFF0FB",
        value: message?.["Goal Overview"],
      },
      {
        label: t("Nutrition Strategy"),
        icon: <NutritionStratergy className="w-[24px] h-[24px]" />,
        tabColor: "#FFF6F0",
        value: message?.["Nutrition Strategy"],
      },
      {
        label: t("Workout Focus"),
        icon: <WorkoutFocus className="w-[24px] h-[24px]" />,
        tabColor: "#F5FFF0",
        value: message?.["Workout Focus"],
      },
      {
        label: t("Long-Term Plan"),
        icon: <LongTerm className="w-[24px] h-[24px]" />,
        tabColor: "#F5FFF0",
        value: message?.["Long-Term Plan"],
      },
    ],
    [message, t]
  );
  return (
    <div className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-xl p-4 py-0">
      {message ? (
        <div className="rounded-lg  min-h-[650px] ">
          <div className="flex justify-center mb-4">
            {/* <p className="bg-[#64DDFF] text-white rounded-full text-[14px] sm:text-[16px] font-[Lato] font-[600] py-1 px-4 ">
              {t("Our Professional Advice For You")}
            </p> */}
          </div>

          <div
            id="scrollable-quiz-container"
            className="h-full max-h-[650px] overflow-y-auto pr-2 custom-scrollbar space-y-2"
          >
            {nutrientData.map(({ label, icon, value, tabColor }, index) => (
              <div
                key={index}
                className="py-4 px-4 md:py-5 md:px-6 rounded-[16px] bg-white border border-[#E6E6E6] flex flex-col gap-2"
                style={{ boxShadow: "7px 7px 9.5px 0px #0000000D" }}
              >
                <div className="relative">
                  <div
                    className={`absolute border border-[#0575e6] -left-3 -top-1 rounded-full min-w-12 min-h-12 flex items-center justify-center border`}
                    style={{ backgroundColor: tabColor }}
                  >
                    {icon}
                  </div>
                  <p className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-[14px] lg:text-[16px] font-[600] text-[#fff] py-2 px-8 md:px-10 rounded-full text-center lg:text-start min-w-[180px] md:min-w-[200px] max-w-full">
                    {label}
                  </p>
                </div>
                <div className="mt-2 md:mt-0">
                  <p className="text-[14px] lg:text-[16px] font-[500] text-[#6C6A6A] font-[Lato] leading-relaxed">
                    {value}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center h-full">
          <img
            src={AdviseMeSidePic}
            alt="Advise Me"
            className="object-cover rounded-[15px] w-full min-h-[500px] max-h-[638px]"
          />
        </div>
      )}
         <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 12px;
        }

        .custom-scrollbar::-webkit-scrollbar-track {
          background-color: #fff !important;
          border-radius: 10px;
          margin: 4px 0;
        }

        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: linear-gradient(150deg, #0771ef 12.89%, #15aafc 85.22%);
          border-radius: 10px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.3);
        }
      `}</style>
    </div>
  );
};

export default AdviseMeRightPanel;
